import * as React from 'react';
import Toggle from 'react-toggle';
const _ = require('lodash');

class SetState {
    fields: any;
}

class SetProps {
    className ?: string;
    title ?: string | null;
    defaultChecked ?: boolean;
    onChange: (fieldset: Array<string>) => void;
}

class FieldState {
}

class FieldProps {
    id: string;
    defaultValue ?: boolean;
    onUpdateSet ?: (event: any) => void;
}

class Field extends React.Component<FieldProps, FieldState> {
        public static defaultProps: Partial<FieldProps> = {
            defaultValue: false
        };

        render() {
            // tslint:disable-next-line:jsx-wrap-multiline
            return <span className="group-by-field">
                <Toggle
                    id={`groupby-${this.props.id}`}
                    icons={false}
                    defaultChecked={this.props.defaultValue}
                    onChange={this.props.onUpdateSet}
                />
                <label
                    className="css-label"
                    htmlFor={`groupby-${this.props.id}`}
                >
                    {this.props.children}
                </label>
            </span>;
        }
    }

class Set extends React.Component<SetProps, SetState> {
        public static defaultProps: Partial<SetProps> = {
            className: 'default'
        };

        componentWillMount() {
            this.setState( {
                fields: this.getActivatedFields()
            });
        }

        getActivatedFields() {
            return React.Children.map(this.props.children, (field: React.ReactElement<any>) => {
                return field.props.defaultValue ? field.props.id : null;
            });
        }

        handleFieldChange(data: any) {
            let tag = data.target.id.startsWith('groupby-') ? data.target.id.substring(8) : data.target.id;
            let set: Array<string>;
            if (data.target.checked) {
                this.setState({fields: set = _.union(this.state.fields, [tag])});
            } else {
                this.setState({fields: set = _.difference(this.state.fields, [tag])});
            }
            if (this.props.onChange !== null)
                this.props.onChange(set);
        }

        render() {
            const fields = React.Children.map(this.props.children, (field: React.ReactElement<any>) =>
                React.cloneElement(field, {
                    defaultValue : (field.props.defaultValue !== undefined)
                        ? field.props.defaultValue
                        : this.props.defaultChecked,
                    onUpdateSet : this.handleFieldChange.bind(this)
                })
            );

            // tslint:disable-next-line:jsx-wrap-multiline
            return <div className={`group-by ${this.props.className}`}>
                    <span className="filter-group">{this.props.title}</span>
                    {fields}
                </div>;
        }
    }

const GroupSet = {
    Set: Set,
    Field: Field
};

export default GroupSet;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/sys/group-set.tsx